module.exports = __webpack_public_path__ + "static/media/jefasdehogar.9fec0907.webp";